/**
 * AI models API — Waba /api/ai/models
 */
import apiClient from 'services/apiClient';

const unwrap = (res) => res?.data;

export const getAiModels = (params = {}) =>
  apiClient.get('ai/models', { params }).then(unwrap);

export const createAiModel = (payload) =>
  apiClient.post('ai/models', payload).then(unwrap);

export const updateAiModel = (id, payload) =>
  apiClient.put(`ai/models/${id}`, payload).then(unwrap);

export const deleteAiModel = (id) =>
  apiClient.delete(`ai/models/${id}`).then(unwrap);

export const testAiModel = (id) =>
  apiClient.post(`ai/models/${id}/test`).then(unwrap);
